/**
 * @description
 * Loader is usually an element that displays the progress status for a task that take a long time or consists of several steps.
 *
 * @specification
 * Adds role 'progressbar' to 'root' slot.
 */
var loaderBehavior = function loaderBehavior() {
  return {
    attributes: {
      root: {
        role: 'progressbar'
      }
    }
  };
};

export default loaderBehavior;